<template>
  <button-fragment @click="onSubmit()">{{ $t(i18n.go_to_details) }}</button-fragment>
</template>

<script>
import {ButtonFragment} from "@bvm/forms";
import {goToSpecialPage} from "@bvm/core/src/api/specialpage/specialpage.api";
import {Utils} from "@bvm/core";

const i18nBuilder = new Utils.I18n.I18nBuilder("claim_damage")
  .add("go_to_details");

export const messageKeys = i18nBuilder.getKeys();

export default {
  name: 'damage-claim-go-to-details',
  components: {
    ButtonFragment
  },
  data() {
    return {
      i18n: i18nBuilder.getData()
    }
  },
  methods: {
    onSubmit() {
      const claimId = new URLSearchParams(window.location.search).get('damageNumber');

      if (claimId) {
        goToSpecialPage("Damage Details",
            {key: 'damageNumber', value: claimId}
        );
      } else {
        goToSpecialPage("DAMAGE_OVERVIEW");
      }
    }
  }
}
</script>
